import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=logged out, obj=logged in
  const [ready, setReady] = useState(false);

  const load = async () => {
    if (window.location.hash?.includes("session_id=")) { setReady(true); return; }
    const token = localStorage.getItem("tp_token");
    if (!token) { setUser(false); setReady(true); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("tp_token");
      setUser(false);
    }
    setReady(true);
  };

  useEffect(() => { load(); }, []);

  const handleAuth = (data) => {
    localStorage.setItem("tp_token", data.token);
    setUser(data.user);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    handleAuth(data);
  };
  const register = async (email, password, display_name) => {
    const { data } = await api.post("/auth/register", { email, password, display_name });
    handleAuth(data);
  };
  const anonymous = async () => {
    const { data } = await api.post("/auth/anonymous");
    handleAuth(data);
  };
  const googleSession = async (session_id) => {
    const { data } = await api.post("/auth/google/session", { session_id });
    handleAuth(data);
    return data.user;
  };
  const secureAccount = async (email, password, display_name) => {
    const { data } = await api.post("/auth/secure-account", { email, password, display_name });
    handleAuth(data);
  };
  const updateProfile = async (payload) => {
    const { data } = await api.put("/auth/profile", payload);
    if (data.token) localStorage.setItem("tp_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("tp_token");
    setUser(false);
  };
  const deleteAccount = async () => {
    await api.delete("/auth/me");
    localStorage.removeItem("tp_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, anonymous, googleSession, secureAccount, updateProfile, logout, deleteAccount, reload: load }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
